import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export interface AgentPermissions {
  readFiles: boolean
  writeFiles: boolean
  runTerminal: boolean
  installPackages: boolean
  browseWeb: boolean
  accessMemory: boolean
}

const DEFAULTS: AgentPermissions = {
  readFiles: true,
  writeFiles: true,
  runTerminal: true,
  installPackages: true,
  browseWeb: true,
  accessMemory: true,
}

interface AgentPermissionsState {
  permissions: Record<string, AgentPermissions> // keyed by projectSlug
  get: (project: string) => AgentPermissions
  set: (project: string, key: keyof AgentPermissions, value: boolean) => void
  reset: (project: string) => void
}

export const useAgentPermissions = create<AgentPermissionsState>()(
  persist(
    (set, get) => ({
      permissions: {},
      get: (project) => get().permissions[project] ?? DEFAULTS,
      set: (project, key, value) => set(s => ({
        permissions: { ...s.permissions, [project]: { ...(s.permissions[project] ?? DEFAULTS), [key]: value } }
      })),
      reset: (project) => set(s => {
        const { [project]: _, ...rest } = s.permissions
        return { permissions: rest }
      }),
    }),
    { name: 'pulse-agent-permissions' }
  )
)
